export default __webpack_public_path__ + "static/media/print-style-2.1732c94a.jpg";